export const TR_ROLE_ROUTES = [
  {
    name: 'Editör',
    path: 'admin.posts.index'
  },
  {
    name: 'Çağrı Merkezi',
    path: 'admin.payment-reminders.index'
  }
]

export const RO_ROLE_ROUTES = [
  {
    name: 'Editor',
    path: 'admin.posts.index'
  }
]
